import React from "react";

const JotForm1 = ({ formData }) => {
  return (
    <>
      <div className="shadow py-2 pb-5 mt-3">
        <iframe
          width="100%"
          height="900px"
          src={`https://form.jotform.com/211995653660060`}
        ></iframe>
      </div>
    </>
  );
};

export default JotForm1;
